import { FC, useState, useEffect } from 'react';
import { SubscriptionSelection } from '@commerce-subscription-webcomponents/ui-composite';
import type { PlanResponse } from '@commerce-subscription-webcomponents/sdk';
import type { SubscriptionContainerPropsTypes } from './types/propsTypes';
import styles from './SubscriptionContainer.module.scss';
import { getValidSubscriptionPlans } from './SubscriptionContainerUtils';
import { SubscriptionContainerIds } from './types/enums';

const SubscriptionContainer: FC<SubscriptionContainerPropsTypes> = ({
  showSubscribeButton,
  subscriptionPlans,
  restrictFromSubscription,
  purchaseType,
  productData,
}: SubscriptionContainerPropsTypes): JSX.Element => {
  const [plans, setPlans] = useState<PlanResponse[]>();

  useEffect(() => {
    setPlans(getValidSubscriptionPlans(subscriptionPlans, restrictFromSubscription));
  }, [subscriptionPlans, restrictFromSubscription, getValidSubscriptionPlans]);

  return (
    <div id={SubscriptionContainerIds.SUBSCRIPTION_CONTAINER}>
      {plans && plans.length > 0 && (
        <div className={styles['cpw-subscription-container']} data-testid="subscription-container-data-testid">
          <SubscriptionSelection
            subscriptionPlans={{ plans: plans }}
            showSubscribeButton={showSubscribeButton}
            purchaseType={purchaseType}
            productData={productData}
          />
        </div>
      )}
    </div>
  );
};

export default SubscriptionContainer;
export type { SubscriptionContainerPropsTypes };
export { SubscriptionContainerIds };
